import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { color } from '@/colors';
import { I18N_KEYS } from '@/language/keys';
import { TextSmRg } from '@/UI/AppTypography/AppTypography';
import { CaretIcon } from '@/UI/Icons/CaretIcon';
import { FlexCenVer, FlexCol } from '@/UI/styles';

export type IteratorSummaryItem = { id: string; name: string; valueCount: number };

const DesignAppIteratorsSummary = ({ iterators }: { iterators: IteratorSummaryItem[] }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(true);

  return (
    <FlexCol sx={{ gap: 1 }}>
      <FlexCenVer
        sx={{ gap: 0.5, justifyContent: 'space-between', cursor: 'pointer' }}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <TextSmRg color={color.White100}>
          {t(I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.ITERATORS_INFO.TITLE)}
        </TextSmRg>
        <CaretIcon
          style={{
            transform: isOpen ? 'rotate(180deg)' : 'none',
            color: color.White64_T,
          }}
        />
      </FlexCenVer>
      {isOpen && (
        <FlexCol sx={{ gap: 0.5 }}>
          {iterators.map((iter) => (
            <FlexCenVer key={iter.id} sx={{ justifyContent: 'space-between', gap: 2, height: 24 }}>
              <TextSmRg color={color.White64_T} noWrap sx={{ flex: 1 }}>
                {iter.name}
              </TextSmRg>
              <FlexCenVer
                sx={{
                  width: 118,
                  height: 24,
                  backgroundColor: color.White04_T,
                  borderRadius: '4px',
                  px: 1,
                }}
              >
                <TextSmRg>
                  {t(I18N_KEYS.RECIPE_MAIN.FLOW.ITERATORS_SECTION.VALUES, { count: iter.valueCount })}
                </TextSmRg>
              </FlexCenVer>
            </FlexCenVer>
          ))}
        </FlexCol>
      )}
    </FlexCol>
  );
};

export default DesignAppIteratorsSummary;
